var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgShare = function SvgShare(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 64",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414A5F",
    d: "M29.653 34.494a15.353 15.353 0 0 0 15.342-15.342v-4.093a15.342 15.342 0 0 0-30.68 0v4.093a15.353 15.353 0 0 0 15.338 15.342M30.392 61.957V51.695a21.95 21.95 0 0 1 2.954-10.963 84 84 0 0 0-3.685-.083 70 70 0 0 0-23.61 3.795A9.235 9.235 0 0 0 0 53.099v9.03a1.044 1.044 0 0 0 1.018 1.045h29.42c-.025-.439-.046-.82-.046-1.217M72.173 20.192c-7.912.41-15.31 3.7-20.986 9.37-6.076 6.07-9.423 14.114-9.423 22.647V64l4.275-9.845c4.993-9.94 15.12-16.53 26.134-17.143v13.587l27.013-22.044L72.173 6.578zm3.367 3.32v-9.859l18.32 14.905-18.32 14.95v-9.907h-1.684c-6.382 0-12.65 1.793-18.124 5.184a34.6 34.6 0 0 0-10.39 9.933c1.73-14.184 13.857-25.206 28.515-25.206z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShare);
export default ForwardRef;